import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import { Utils } from '../../utils/utils';
import { useBookmarks } from '../../hooks/useBookmarks';
import './livro.css';

import {
  Preloader
} from '../../components';
import AuthorService from '../../services/AuthorService';
import { loadReaderSettings, saveReaderSettings, applyReaderSettings, getTextColor, COLORS } from '../../utils/readerSettings';

export default class ViewLivro extends Component {
  constructor(props) {
    super(props);

    const file = props.match.params.file;
    const cached = this.loadFromCache(file);
    this.state = {
      "url": cached?.url || null,
      "book": cached?.book || null,
      "contentUid": cached?.contentUid || null,
      "referenceUid": cached?.referenceUid || null,
      "bookmarks": [],
      "lastInteraction": null,
      "summary": null,
      "summaryLoading": false
    }
    
    this.handleBookmarkEvent = this.handleBookmarkEvent.bind(this);
  }

  loadFromCache(file) {
    try {
      const raw = localStorage.getItem(`livro_${file}`);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  saveToCache(file, data) {
    try {
      localStorage.setItem(`livro_${file}`, JSON.stringify(data));
    } catch {
      // localStorage cheio ou indisponível
    }
  }

  isEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  componentDidMount() {
    const navigateTo = this.props.location?.state?.navigateTo;

    if (navigateTo) {
      this.setState({ navigateTo });
    }

    this.getReferences();
    // Escutar eventos de marcações do player
    window.addEventListener('message', this.handlePlayerMessage);
    // Escutar eventos de botão voltar do player
    window.addEventListener('message', this.handleBackButtonMessage);
    // Escutar mudanças nas configurações de leitura
    window.addEventListener('reader-settings-changed', this.handleReaderSettingsChanged);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handlePlayerMessage);
    window.removeEventListener('message', this.handleBackButtonMessage);
    window.removeEventListener('reader-settings-changed', this.handleReaderSettingsChanged);
  }

  handleBackButtonMessage = (event) => {
    if (event.data.type === 'BACK_BUTTON_CLICKED' || event.data.onBack) {
      const now = Date.now();
      if (now - (this._lastBackPress || 0) < 1000) return;
      this._lastBackPress = now;

      const from = this.props.location.state?.from;
      if (from) {
        this.props.history.push(from);
      } else {
        this.props.history.replace(`/book/${this.props.match.params.file}`);
      }
    }
  }

  handlePlayerMessage = async (event) => {
    if (!event.data || typeof event.data !== 'object') return;

    // console.log(event);

    // Resposta a pedidos do player
    if (event.data.requestReaderSettings) {
      this.sendReaderSettingsToPlayer();
      return;
    }

    const { userInteraction, requestHighlights, createCitation, requestSummary } = event.data;
    
    if (requestHighlights) {
      // Enviar marcações existentes para o player

      // for(var i = 0; i < this.state.bookmarks.length; i++) {
      //   this.deleteBookmark(this.state.bookmarks[i]);
      // }
      this.sendBookmarksToPlayer();
      return;
    }

    // if(requestEpubJsonData){
    //   const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    //   if (iframe?.contentWindow) {
    //     iframe.contentWindow.postMessage({
    //       requestEpubJsonData: true
    //     }, '*');
    //   }
    //   return;
    // }

    if (requestSummary) {
      if (!this.state.summary) {
        await this.loadSummary();
      }
      this.sendSummaryToPlayer();
      return;
    }

    if (event.data.readerSettings) {
      var rs = event.data.readerSettings;
      var expandHex = function (h) {
        var r = h;
        if (r && r.length === 4 && r[0] === '#') r = '#' + r[1] + r[1] + r[2] + r[2] + r[3] + r[3];
        return r ? r.toUpperCase() : '';
      };
      var rawBg = rs.backgroundColor || '#d4d3c8';
      var expandedBg = expandHex(rawBg);
      var matched = COLORS.find(function (c) { return expandHex(c.bg) === expandedBg; });
      var bgColor = matched ? matched.bg : rawBg;
      var existing = loadReaderSettings();
      var settings = {
        ...existing,
        fontSize: rs.fontSize !== undefined ? rs.fontSize : existing.fontSize,
        fontFamily: rs.fontFamily || 'Padrão',
        backgroundColor: bgColor,
        textColor: matched ? matched.text : getTextColor(bgColor),
        highContrast: rs.highContrast !== undefined ? rs.highContrast : existing.highContrast,
        dyslexiaFont: rs.dyslexiaFont !== undefined ? rs.dyslexiaFont : existing.dyslexiaFont
      };
      saveReaderSettings(settings);
      applyReaderSettings(settings);
      try { window.dispatchEvent(new CustomEvent('reader-settings-changed', { detail: settings })); } catch (e) {}
      return;
    }

    if (createCitation) {
      this.handleCreateCitation(createCitation.text);
      return;
    }

    if (userInteraction) {
      this.handleBookmarkEvent(userInteraction.type, userInteraction.userData);
    }
    this.sendBookmarksToPlayer();
    this.sendProgressToPlayer();
    this.sendNavigationToPlayer();
  }

  sendNavigationToPlayer = () => {

    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow && this.state.navigateTo)  {
      // console.log(this.state.navigateTo)
      iframe.contentWindow.postMessage({
        navigateTo: JSON.stringify(this.state.navigateTo),
      }, '*');
    }
  }

  handleBookmarkEvent = async (type, userData) => {
    try {
      // Extract target_uid from content URL
      const fileUid = this.state.contentUid;
      const referenceUid = this.state.referenceUid;
      const updatedUserData = { ...userData, target_uid: fileUid || userData.target_uid , context_uid: referenceUid || userData.context_uid };
      
      switch (type) {
        case 'highligth': // Manter typo para compatibilidade
          await this.createBookmark(updatedUserData);
          break;
        case 'note':
          await this.updateBookmark(updatedUserData);
          break;
        case 'delete':
          await this.deleteBookmark(updatedUserData);
          break;
        case 'trackProgress':
          await this.saveProgress(updatedUserData);
          break;
      }
      // Recarregar marcações após operação
      await this.loadBookmarks();
      await this.sendBookmarksToPlayer();
    } catch (error) {
      console.error('Error handling bookmark event:', error);
    }
  }

  createBookmark = async (bookmarkData) => {
    // const connectors = Sdk.Api.authorization.user.directory.connectors;
    const connectors = Sdk.Api.authorization.activeProject.connectors;
    const connectorUser = connectors?.find(c => c.type === "UserData_1");
    
    if (!connectorUser) {
      throw new Error('UserData connector not found');
    }

    // Determine external_type based on content reference type
    const externalType = this.getExternalTypeForBookmark();

    const userDataParams = {
      ...bookmarkData,
      external_type: externalType,
      target_type: "ManagedContentReference",
      context_type: "ManagedContent",
      context_uid: this.state.contentUid,
      target_uid: this.state.referenceUid,
      name: null,
    };

    const url = `cms/v1.1/user/connector/uid/${connectorUser.uid}/data`;
    return await Sdk.Api.dynamic.bridge(url, userDataParams, "POST");
  }

  updateBookmark = async (bookmarkData) => {
    const bookmarkUid = bookmarkData.uid;
    if (!bookmarkUid) return;

    const url = `cms/v1.1/user/data/uid/${bookmarkUid}`;
    const updates = {
      description: bookmarkData.description,
      external_data: bookmarkData.external_data,
    };
    return await Sdk.Api.dynamic.bridge(url, updates, "PUT");
  }

  deleteBookmark = async (bookmarkData) => {
    const bookmarkUid = bookmarkData.uid;
    if (!bookmarkUid) return;

    const url = `cms/v1.1/user/data/uid/${bookmarkUid}`;
    return await Sdk.Api.dynamic.bridge(url, null, "DELETE");
  }

  loadBookmarks = async () => {
    if (!this.state.referenceUid) return;
    
    try {
      const url = `cms/v1.1/user/data?target_uid=${this.state.referenceUid}`;
      const response = await Sdk.Api.dynamic.bridge(url, null, "GET");
      
      if (response.result) {
        const bookmarks = response.result.filter(item => 
          item.target_type === "ManagedContentReference" && 
          item.context_type === "ManagedContent"
        );
        this.setState({ bookmarks });
      }
    } catch (error) {
      console.error('Error loading bookmarks:', error);
    }
  }

  sendBookmarksToPlayer = () => {
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow) {
      const mimeType = this.getMimeTypeFromReference();
      
      if (mimeType === 'application/epub+zip') {
        // Estrutura para EPUB
        iframe.contentWindow.postMessage({
          userData: JSON.stringify(this.state.bookmarks),
          lastInteraction: this.state.lastInteraction,
          navigateTo: this.state.navigateTo,
          type: "RDPEvent:user_interaction"
        }, '*');
      } else {
        // Estrutura para PDF
        iframe.contentWindow.postMessage({
          loadHighlights: this.state.bookmarks,
          navigateTo: this.state.navigateTo,
        }, '*');
      }
    }
  }

  sendAppVersion = () => {
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow) {
      iframe.contentWindow.postMessage({
        app_version: "v4"
      }, '*');
    }
  }

  loadProgress = async () => {
    if (!this.state.referenceUid) return;

    try {
      // First create interaction by accessing content
      const contentUrl = `cms/v1.1/managed/content/reference/uid/${this.state.referenceUid}/content`;
      await Sdk.Api.dynamic.bridge(contentUrl, null, "GET");
      
      // Then get the interaction data
      const interactionUrl = `cms/v1.1/managed/content/reference/uid/${this.state.referenceUid}/interaction`;
      const response = await Sdk.Api.dynamic.bridge(interactionUrl, null, "GET");

      if (response) {
        this.setState({ lastInteraction: response });
        return response;
      }
    } catch (error) {
      console.error('Error loading progress:', error);
    }
    return null;
  }

  saveProgress = async (progressData) => {
    if (!this.state.lastInteraction) return;
    // const connectors = Sdk.Api.authorization.user.directory.connectors;
    const connectors = Sdk.Api.authorization.activeProject.connectors;
    const connectorUser = connectors?.find(c => c.type === "UserData_1");
    try {
      const params = {
        ...this.state.lastInteraction,
        ...progressData,
        activity_data: JSON.stringify(progressData.activity_data),
      };

      // console.log(progressData)
      
      // Avoid duplicate updates
      if (this.state.lastInteraction.activity_data === params.activity_data) return;
      
      const url = `cms/v1.1/managed/content/interaction/uid/${this.state.lastInteraction.uid}`;
      const result = await Sdk.Api.dynamic.bridge(url, params, "PUT");
      
      this.setState({ lastInteraction: result });
      return result;
    } catch (error) {
      console.error('Error saving progress:', error);
      throw error;
    }
  }

  sendProgressToPlayer = () => {
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow && this.state.lastInteraction) {
      let progressData = this.state.lastInteraction;

      const mimeType = this.getMimeTypeFromReference();
      
      if (mimeType === 'application/epub+zip') {
        // Estrutura para EPUB
        console.log(this.state.lastInteraction)
        iframe.contentWindow.postMessage({
          lastInteraction: this.state.lastInteraction,
          type: "RDPEvent:user_interaction",
        }, '*');
      } else {
        if (typeof progressData.activity_data === 'string') {
          try {
            progressData = {
              ...progressData,
              data: JSON.parse(progressData.activity_data),
            };
          } catch (e) {
            console.error('Error parsing progress data:', e);
          }
        } else if (progressData.activity_data) {
          progressData = {
            ...progressData,
            data: progressData.activity_data,
          };
        }

        iframe.contentWindow.postMessage({
          loadProgress: progressData
        }, '*');
      }    
      
    }
  }

  handleReaderSettingsChanged = () => {
    this.sendReaderSettingsToPlayer();
  }

  sendReaderSettingsToPlayer = () => {
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow) {
      const settings = loadReaderSettings();
      iframe.contentWindow.postMessage({
        readerSettings: {
          fontSize: settings.fontSize,
          fontFamily: settings.fontFamily,
          backgroundColor: settings.backgroundColor,
          textColor: settings.textColor,
          highContrast: settings.highContrast,
          dyslexiaFont: settings.dyslexiaFont
        }
      }, '*');
    }
  }

  copySelectedText = async(text) => {
    const {book} = this.state;
    const authors = await AuthorService.updateContentAuthor(book, await AuthorService.loadAuthors(), ', ');
    const year = book.properties.find(x => x.name === 'Ano de Publicação')?.value || '';
    try {
      const formattedText = `
      "${text}"      
      
      ${authors.trim()}, ${book.name}, São Paulo, Editora Senac, ${year}, Disponível na Biblioteca Digital Senac. 
      `;
      navigator.clipboard.writeText(formattedText);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }

  }

  handleCreateCitation = async (text) => {
    let success = false;
    try {
      await this.copySelectedText(text);
      success = true;
    } catch (error) {
      console.error('Error creating citation:', error);
    }
    
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow) {
      iframe.contentWindow.postMessage({
        citationStatus: { success }
      }, '*');
    }
  }

  extractFileUidFromUrl = (url) => {
    if (!url) return null;
    const match = url.match(/reference\/uid\/([^/]+)/);
    return match ? match[1] : null;
  }

  loadSummary = async () => {
    if (!this.state.referenceUid || !this.state.book) return;
    
    this.setState({ summaryLoading: true });
    
    try {
      const mimeType = this.getMimeTypeFromReference();
      let summary = null;
      
      if (mimeType === 'application/epub+zip') {
        summary = await this.getEpubSummary(this.state.referenceUid);
      } else if (mimeType === 'digitalpages/pdf') {
        summary = await this.getPdfSummary(this.state.referenceUid);
      }
      
      this.setState({ 
        summary: summary,
        summaryLoading: false 
      });
    } catch (error) {
      console.error('Error loading summary:', error);
      this.setState({ 
        summary: null,
        summaryLoading: false 
      });
    }
  }

  getMimeTypeFromReference = () => {
    // Determina o tipo MIME baseado na referência atual
    const { book, referenceUid } = this.state;
    if (book && book.references && referenceUid) {
      const reference = book.references.find(ref => ref.uid === referenceUid);
      if (reference) {
        return reference.mime_type;
      }
    }
    
    // Fallback para URL se não encontrar na referência
    const url = this.state.url;
    if (url && url.includes('epub')) {
      return 'application/epub+zip';
    } else if (url && url.includes('pdf')) {
      return 'digitalpages/pdf';
    }
    return 'application/epub+zip'; // Default to epub
  }

  getExternalTypeForBookmark = () => {
    const mimeType = this.getMimeTypeFromReference();
    if (mimeType === 'digitalpages/pdf') {
      return 'mark-pdf';
    }
    return 'mark-epub'; // Default for epub and other types
  }

  getEpubSummary = async (uid) => {
    try {
      const url = `cms/v1.1/managed/content/reference/uid/${uid}/default/target`;
      const response = await Sdk.Api.dynamic.bridgeUrl(url, null);
      
      // Validar URL antes de fazer fetch
      if (!this.validateUrl(response)) {
        throw new Error('Invalid URL for content fetch');
      }
      
      const contentToc = await fetch(response);
      const contentTocUrl = contentToc.url.replace("content.opf?", "toc.ncx?");
      
      // Validar URL do TOC
      if (!this.validateUrl(contentTocUrl)) {
        throw new Error('Invalid URL for TOC fetch');
      }
      
      const manifest = await fetch(contentTocUrl).then(p => p.text());
      
      const parser = new DOMParser();
      const xml = parser.parseFromString(manifest, "text/xml");
      const navPoints = xml.getElementsByTagName("navPoint");
      
      return this.parseEpubSummary(navPoints);
    } catch (error) {
      console.error('Error getting ePUB summary:', error);
      return null;
    }
  }

  validateUrl = (url) => {
    try {
      const urlObj = new URL(url);
      // Lista de domínios permitidos
      const allowedDomains = [
        'api.digitalpages.com.br',
        'digitalpages.com.br'
      ];
      
      // Verificar se o domínio está na lista permitida
      if (!allowedDomains.includes(urlObj.hostname)) {
        throw new Error('Domain not allowed');
      }
      
      // Bloquear IPs privados
      const privateIpRegex = /^(127\.|10\.|172\.(1[6-9]|2[0-9]|3[01])\.|192\.168\.|169\.254\.)/;
      if (privateIpRegex.test(urlObj.hostname)) {
        throw new Error('Private IP not allowed');
      }
      
      return true;
    } catch (error) {
      console.error('URL validation failed:', error);
      return false;
    }
  }

  parseEpubSummary = (navPoints) => {
    const result = [];
    
    const removeExtraSpace = (s) => 
      s?.trim()
       .split(/ +/)
       .join(" ")
       .replace(/(\r\n|\n|\r)/gm, "");
    
    Array.from(navPoints).forEach((navPoint) => {
      const content = navPoint.getElementsByTagName('content')[0];
      const navLink = content?.getAttribute('src');
      
      result.push({
        type: "epub",
        uid: navPoint.id?.toString(),
        title: removeExtraSpace(navPoint.textContent),
        navLink
      });
    });
    
    return result;
  }

  getPdfSummary = async (uid) => {
    try {
      const url = `cms/v1.1/managed/content/reference/uid/${uid}/default/target`;
      const response = await Sdk.Api.dynamic.bridge(url, null, "GET");
      
      if (response && response.sections) {
        return this.parsePdfSummary(response);
      }
      
      return null;
    } catch (error) {
      console.error('Error getting PDF summary:', error);
      return null;
    }
  }

  parsePdfSummary = (serverData) => {
    const result = [];
    
    if (serverData && serverData.sections) {
      const pageSets = serverData.sections[0].pageSets;
      
      pageSets.forEach((pageSet) => {
        const navLink = {
          page: pageSet.orderIndex,
          section: pageSet.sectionIndex
        };
        
        result.push({
          type: "pdf",
          uid: pageSet.portrait.linkPage,
          title: pageSet.portrait.bookmark,
          navLink: JSON.stringify(navLink)
        });
      });
    }
    
    return result;
  }

  sendSummaryToPlayer = () => {
    const iframe = document.querySelector('.rdp-react-template-view-livro-iframe');
    if (iframe?.contentWindow && this.state.summary) {
      iframe.contentWindow.postMessage({
        loadSummary: this.state.summary
      }, '*');
    }
  }

  checarRedirect = async (url) => {
    try {
      const response = await fetch(url);
      return response.url;
    } catch (error) {
      return url;
    }
  }

  isAppContext() {
    return !!(
      window.cordova ||
      window.CordovaExec ||
      localStorage.getItem("iammobile") !== null ||
      ["app:", "file:"].includes(window.location.protocol)
    );
  }

  async getReferences() {
    var _this = this;
    var file = this.props.match.params.file;
    var reference = this.props.match.params.reference;

    var [groupedContent, content] = await Promise.all([
      Utils.bridgeAndStore(`/cms/v1.1/managed/content/group/uid/${file}`),
      Sdk.Api.dynamic.bridgeUrl(`cms/v1.1/managed/content/reference/uid/${reference}/content`, null),
    ]);

    // var groupedContent = await Utils.bridgeAndStore(`/cms/v1.1/managed/content/group/uid/${file}`);

    // var content = await Sdk.Api.dynamic.bridgeUrl(`cms/v1.1/managed/content/reference/uid/${reference}/content`, null);
    content += "&app_version=v4";
    if (window.location.href.search("/homolog/") > -1 || this.isAppContext()) {
      var newContent = await _this.checarRedirect(content);
      content = newContent.replace("/current/", "/homolog/");
    }

    // content = 'http://localhost:3001/#/?custom_options=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#/'

    const cached = this.loadFromCache(file);

    const primaryData = {
      contentUid: file,
      book: groupedContent,
      referenceUid: reference,
      url: content
    };
    const merged = { ...cached, ...primaryData };
    if (!cached || !this.isEqual(cached, merged)) {
      this.saveToCache(file, merged);
    }

    this.setState(primaryData);

    await Promise.all([
      this.loadBookmarks(),
      this.loadProgress(),
    ]);
  }

  redirectTo(path) {
    this.props.history.push(path);
  }

  getCustomOptions() {
    return `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`;
  }

  render() {
    const { url } = this.state;
    var _this = this;
    return <div className="rdp-react-template-view-livro">
      {url === null &&
        <Preloader/>
      }
      {url !== null &&
        <iframe 
          className="rdp-react-template-view-livro-iframe" 
          title="book-player"
          onLoad={(e) => {
            // e.target.contentWindow.postMessage({
            //   app_version: "v4"
            // }, '*');
            // Enviar dados iniciais para o player
              const mimeType = this.getMimeTypeFromReference();
              
              if (mimeType === 'application/epub+zip') {
                // Estrutura para EPUB (seguindo js_app_senac)
                e.target.contentWindow.postMessage({
                  userData: JSON.stringify(this.state.bookmarks),
                  lastReference: null,
                  navigateTo: this.state.navigateTo,
                  lastInteraction: this.state.lastInteraction,
                  type: "RDPEvent:user_interaction",
                  app_version: "v4"
                }, '*');
              } else {
                // console.log("frame load", this.state.bookmarks, this.state.lastInteraction);
                // Estrutura unificada para PDF (seguindo padrão EPUB)
                e.target.contentWindow.postMessage({
                  loadHighlights: this.state.bookmarks,
                  loadProgress: this.state.lastInteraction,
                  navigateTo: this.state.navigateTo,
                  app_version: "v4"
                }, '*');
              }
              _this.sendReaderSettingsToPlayer();
            }
          }
          src={url}
        />
      }
    </div>;
  }
}
